import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import type {CompetitionViewModel} from "../../../../../domain/common/competition/models/competition-view-model";
import {computed} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {TransfersTabModel} from "../transfers.tab-model";
import {CompetitionTransfersPageLinkModel} from "../../../../../containers/competition-container/pages/transfers-page/models/competition-transfers-page.link-model";

export class CompetitionTransfersPageTabModel extends TransfersTabModel {
  index: Number;
  name: String;
  entity: CompetitionViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitionViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitionTransfersPageLinkModel {
    const linkModel: CompetitionTransfersPageLinkModel = new CompetitionTransfersPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.transfers;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }
}
